import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-error-section',
  templateUrl: './error-section.component.html',
  styleUrls: ['./error-section.component.scss'],
})
export class ErrorSectionComponent {
  @Input() description = 'Failed to Save';
  @Input() icon = 'exclamation-circle';
  @Input() containerClass = '';
}
